<style scoped lang="scss">
  .content-block-footer {
    display: flex;
    align-items: center;
    padding: 0px 20px 12px 20px;

    .locale-select {
      display: flex;
      align-items: center;

      .icon {
        color: $gray;
      }

      .language-picker {
        margin-left: 5px;
      }
    }

    @include media(max, sm) {
      @include padding-x(15px);
      flex-direction: column;
      align-items: flex-start;
    }
  }
</style>

<template>
  <div class="content-block-footer">
    <div class="locale-select">
      <icon name="globe"/>
      <dropdown-select
        v-model="localeModel"
        :options="localeOptions"
        class="language-picker"
        :class="{left: $appIsSM}"/>
    </div>
  </div>
</template>

<script>

import { i18n, saveLocale, localesDataList } from '@src/localization/config'

export default {
  name: 'ContentBlockFooter',
  computed: {
    localeOptions() {
      return localesDataList
        .map(locale => ({
          value: locale.code,
          label: locale.name,
        }))
    },

    localeModel: {
      get() {
        return i18n.locale
      },
      set(value) {
        this.$tmr.goal('language_changed')

        saveLocale(value)
        window.location.reload()
      },
    },
  },
}
</script>
